<template>
  <vuestic-layout v-layout>
    <app-navbar :isOpen="opened" @toggle-menu="toggleSidebar" />
    <app-sidebar :isOpen="showMenu" @toggle-menu="toggleSidebar" />
    <main
      slot="content"
      id="content"
      class="content va-layout gutter--lg fluid"
      style="padding-top: 0;"
      role="main"
    >
      <app-breadcrumbs />

      <router-view />
      <div class="business-manager-fix">
        <business-manager></business-manager>
      </div>
    </main>
    <span slot="footer">
      <div class="va-row" style="text-align: center; margin-top: 3rem">
        <div :class="`flex ${VUE_APP_TERMS?'md4':'md6'}`" v-if="VUE_APP_DOCS">
          <a target="_blank" :href="VUE_APP_DOCS">{{'t.docs' | translate}}</a>
        </div>
        <div :class="`flex ${VUE_APP_TERMS?'md4':'md6'}`" v-if="VUE_APP_PRIVACY">
          <a target="_blank" :href="VUE_APP_PRIVACY">{{'t.privacy' | translate}}</a>
        </div>
        <div class="flex md4" v-if="VUE_APP_TERMS">
          <a target="_blank" :href="VUE_APP_TERMS">{{'t.terms' | translate}}</a>
        </div>
      </div>
      <div class="va-row" style="text-align: center; margin-top: 1rem">
        <p style="padding-top: 5px">
          {{'t.copyrightPagsmile1' | translate}} {{` ${new Date().getFullYear()} ${VUE_APP_NAME}` }} {{'t.copyrightPagsmile2' | translate}}
        </p>
      </div>
    </span>
  </vuestic-layout>
</template>

<script>
import VuesticLayout from '../../vuestic-theme/vuestic-components/vuestic-layout/VuesticLayout'
import AppNavbar from './app-navbar/AppNavbar'
import AppSidebar from './app-sidebar/AppSidebar'
import AppBreadcrumbs from './app-breadcrumbs/AppBreadcrumbs'
import Layout from '../../vuestic-theme/vuestic-directives/Layout'
import { mapGetters, mapMutations } from 'vuex'
import Spinner from 'vue-simple-spinner'
import BusinessManager from '@/package/BusinessManager.vue'

export default {
  name: 'app-layout',
  components: {
    VuesticLayout,
    AppNavbar,
    AppSidebar,
    AppBreadcrumbs,
    Spinner,
    BusinessManager
  },
  directives: {
    layout: Layout
  },
  data () {
    return {
      opened: true,
      uid: '',
      token: localStorage.getItem('Authorization'),
      userInfo: '',
      permissions: {
        Dashboard: false,
        PaymentOrder: false,
        Report: false,
        App: false,
        MerchantKyc: false,
        UserManagement: false,
        Finance: false,
        WayBill: false,
      },
      VUE_APP_NAME: process.env.VUE_APP_NAME,
      VUE_APP_DOCS: process.env.VUE_APP_DOCS,
      VUE_APP_PRIVACY: process.env.VUE_APP_PRIVACY,
      VUE_APP_TERMS: process.env.VUE_APP_TERMS
    }
  },
  methods: {
    ...mapMutations(['setUser']),
    toggleSidebar (opened) {
      this.opened = opened
    }
  },
  computed: {
    ...mapGetters(['isLoading']),
    showMenu: function () {
      if (document.body.clientWidth && document.body.clientWidth < 991.1) {
        return !this.opened
      }
      return this.opened
    }
  },
  mounted () {
    if (!this.showMenu) {
      let sidebar = document.querySelector('.vuestic-sidebar')
      sidebar.classList.add('sidebar-hidden')
    }
  }
}
</script>

<style>
.made-by-footer {
  background-color: #333333;
}
</style>

<style lang="scss" scoped>
.spinner {
  margin-top: 200px;
}
.business-manager-fix{
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99999;
}
</style>
